import { ApiResourceBaseClass as a } from "./baseApiCalls.js";
class g extends a {
  /**
   * Lists messaging settings.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/messaging/settings`
   *
   * @param {number} [page] - Page number for paginated results.
   * @param {string | undefined} [business_id] - Id of the business to filter on.
   * @returns {Promise<PaginatedBmSettings>} A promise resolving to the data containing the messaging settings.
   */
  getSettings = async (s, t) => {
    const { data: e } = await this.get("messaging/settings", {
      page: s,
      business__in: t,
      partoo_ui: !0
    });
    return e;
  };
  /**
   * Fetches settings stats.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/api/v2/messaging/settings/stats`
   *
   * @returns {Promise<MessagingSettingsStats>} A promise resolving to an object containg settings stats.
   */
  messagingSettingsStats = async () => {
    const { data: s } = await this.get("messaging/settings/stats");
    return s;
  };
}
export {
  g as MessagingSettings,
  g as default
};
